module.exports = __webpack_public_path__ + "assets/retina_MidpointDetailed.fee80f687b78b6305a34ed9658dd0bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_MidpointDetailed.png
// module id = 692
// module chunks = 0